import React, { useRef, useEffect, useState } from 'react';
import WebViewer from '@pdftron/webviewer';
import { initializeVideoViewer, annotManager, annotationManager } from '@pdftron/webviewer-video';

import { Waveform, initializeAudioViewer } from '@pdftron/webviewer-audio';
import { demoPeaks, demoXFDFString, } from './demo-vars';
// import { Button } from 'react-bootstrap';
import { Link, useHistory } from "react-router-dom";
import { Button, Modal } from "react-bootstrap";
import userService from "../../services/user.service";
import {
  getFromLocalStorage,
} from "../../utils/webStorage";
import { CircularProgress } from "@material-ui/core";

import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent";
import successimg from "../../assets/images/successimg.png";
import close from "../../assets/images/crosstick.png";
import { BsXLg } from "react-icons/bs";

const viewerElement = document.getElementById('viewer');
const DOCUMENT_ID = 'video';



const PdfTorn = (props) => {
  const viewer = useRef(null);
  const inputFile = useRef(null);


  //video URL
  const urlVideo = props.location.state.annotVidURL;
  const [state, setState] = useState({ instance: null, videoInstance: null, audioInstance: null });
  const [originalVideo, setoriginalVideo] = useState('');
  const [editedVideoName, setEditedVideoName] = useState('');
  const [categoryId, setCategoryId] = useState('');
  const [eventId, setEventId] = useState('');
  const [playlistId, setPlaylistId] = useState('');
  const [schoolId, setSchoolId] = useState('');
  const [annotedVideoUrl, setAnnotedVideoUrl] = useState('');
  const [showModal, setShowModal] = useState(false);
  const [showLoading, setShowLoading] = useState(false);
  const [errorPlaylistName, setErrorPlaylistName] = useState('');
  const [openSuccessDialogue, setOpenSuccessDialogue] = useState(false);
  const [finalAnnotationData, setFinalAnnotationData] = useState([]);

  // const [uploadlicenseArray, setStateArray] = useState([]);
  const license = `---- Insert commercial license key here after purchase ----`;
  var checkArray = []


  // if using a class, equivalent of componentDidMount

 
  useEffect(() => {
    var categoryId = getFromLocalStorage("categoryId");
    var eventId = getFromLocalStorage("eventId");
    var playlistId = getFromLocalStorage("playlistId");
    var schoolId = getFromLocalStorage("schoolId");
  
    setCategoryId(categoryId);
    setEventId(eventId);
    setPlaylistId(playlistId);
    setSchoolId(schoolId);

    console.log("Url", state);
    if (urlVideo !== '') {
      WebViewer(

        {
          path: '/webviewer/lib',
          selectAnnotationOnCreation: true
        },
        viewer.current,
      ).then(async instance => {

        const audioInstance = await initializeAudioViewer(
          instance,
          { license },
        );

        const videoInstance = await initializeVideoViewer(
          instance,
          {
            license,
            AudioComponent: Waveform,
            generatedPeaks: !process.env.DEMO ? null : demoPeaks // waves can be pre-generated as seen here for fast loading: https://github.com/bbc/audiowaveform
          }
        );

        instance.openElements('notesPanel');
        instance.setTheme('dark');

        setState({ instance, videoInstance, audioInstance });


        // Load a video at a specific url. Can be a local or public link
        // If local it needs to be relative to lib/ui/index.html       .
        // Or at the root. (eg '/video.mp4'
        videoInstance.loadVideo(urlVideo);
        initializeHeader(instance);

        const { docViewer } = instance;

        instance.UI.setHeaderItems(header => {
          header.push({
            type: 'actionButton',
            img: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M0 0h24v24H0z" fill="none"/><path d="M17 3H5c-1.11 0-2 .9-2 2v14c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V7l-4-4zm-5 16c-1.66 0-3-1.34-3-3s1.34-3 3-3 3 1.34 3 3-1.34 3-3 3zm3-10H5V5h10v4z"/></svg>',
            onClick: async () => {
              // GetVideo
              const video = videoInstance.getVideo();

              //GetAnnotation
              let annotatedImage = [];
              var p = 0
              annotatedImage = await video.getAnnotationCanvasesWithIntervals();
              // console.log("image",annotatedImage[0].image);

              //Create New Array for
              console.log("videoURL", urlVideo)
              setoriginalVideo(urlVideo);
              if (annotatedImage.length != 0) {
                let arrayURLData = []
                var obj = {}
                obj["videoURL"] = urlVideo;
                obj["startTimeImage"] = annotatedImage[p].startTime
                obj["endTimeImage"] = annotatedImage[p].endTime

                // obj["endTime"]=annotatedImage[p].endTime;

                arrayURLData.push(obj)
                //Push annotation in arrayURLData
                arrayURLData.push(annotatedImage);
                console.log(annotatedImage)
                p = p + 2;
                // console.log("arsray", arrayURLData)
                // console.log("arsray", arrayURLData[1][0].image)

                const callAnnotatioImage = () => {
                  console.log("postAPI", annotatedImage[0].image);
                  var base64 = annotatedImage[0].image.slice(22);


                  userService
                    .annotationBase64Post(base64)
                    .then((res) => {
                      var sendAnnotationArray = []
                      var annotateImageArray = res.data.data;
                      obj["videoImg"] = annotateImageArray
                      sendAnnotationArray.push(obj);
                      checkArray.push(obj);
                      setFinalAnnotationData(checkArray)
                      console.log(checkArray)
                    });
                }
                callAnnotatioImage()

              }
              // callAnnotatioImage(annotatedImage)



            }
          });
          header.push({
            type: 'actionButton',
            img: '<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-scissors" viewBox="0 0 16 16"><path d="M3.5 3.5c-.614-.884-.074-1.962.858-2.5L8 7.226 11.642 1c.932.538 1.472 1.616.858 2.5L8.81 8.61l1.556 2.661a2.5 2.5 0 1 1-.794.637L8 9.73l-1.572 2.177a2.5 2.5 0 1 1-.794-.637L7.19 8.61 3.5 3.5zm2.5 10a1.5 1.5 0 1 0-3 0 1.5 1.5 0 0 0 3 0zm7 0a1.5 1.5 0 1 0-3 0 1.5 1.5 0 0 0 3 0z"/></svg>',
            onClick: async () => {

              // const redirect = () => {
                // history.push('/your-path')

                history.push({
                  pathname: '/videoeditor',
                  state: { clippingURL: props.location.state.annotVidURL }
              });
              // }
              
            }
          });
          
        });

        // const callAnnotatioImage = (data) => {
        //   console.log("postAPI",data[0].image);
        //  var base64 = data[0].image.slice(22);

        //  console.log("base64 Test", base64)
        //   userService
        //    .annotationBase64Post(base64)
        //    .then((res) => {

        //     });
        // }

        const onDocumentLoaded = async () => {
          const video = videoInstance.getVideo();
          const annotationCanvasesWithTntervals = video.getAnnotationCanvasesWithIntervals();
          console.log("annotationCanvasesWithTntervals", annotationCanvasesWithTntervals);
        };



        // Load saved annotations
        docViewer.addEventListener('documentLoaded', onDocumentLoaded);

        return () => {
          docViewer.removeEventListener('documentLoaded', onDocumentLoaded);
          
        };
      });



    }


  }, []);

  const savePlaylistName = (name) => {
    setEditedVideoName(name)
  }

  const saveAnnotationVideo = () => {
    setShowLoading(true);
    userService.annotateVideoApi(finalAnnotationData).then((res) => {
      if (res.data.data) {
        var annotedVideoUrl = res.data.data;
        setAnnotedVideoUrl('/home/ubuntu/node' + annotedVideoUrl);
        setShowLoading(false);
        handleModelfive();
      }
    });
  }

  const saveAnnotationVideoSaveApi = () => {
    if (editedVideoName == "") {
      setErrorPlaylistName("Name is required!")
    } else {
      setErrorPlaylistName("")
      userService.MergeVideoUrlSend(categoryId, eventId, playlistId, annotedVideoUrl, editedVideoName, schoolId).then((res) => {
        handleModelfiveClose();
        setOpenSuccessDialogue(true)
      });
    }
  }

  const handleModelfive = () => {
    // this.setState({ showfive: !this.state.showfive })
    setShowModal(true);

  }

  const handleModelfiveClose = () => {
    setShowModal(false)
  }

  const handleDialogueClose = () => {
    setOpenSuccessDialogue(false)
  }


  const onFileChange = async event => {
    const file = event.target.files[0];
    const url = URL.createObjectURL(file);
    const { instance, videoInstance, audioInstance } = state;

    // Seamlessly switch between PDFs and videos.
    // Can also detect by specific video file types (ie. mp4, ogg, etc.)
    if (file.type.includes('video')) {
      videoInstance.loadVideo(url, { fileName: file.name, });
      // TODO: Notespanel needs to be delayed when opening. Not sure why.
      setTimeout(() => {
        instance.openElements('notesPanel');
      });
    } else if (file.type.includes('audio')) {
      audioInstance.loadAudio(url);

      setTimeout(() => {
        instance.openElements('notesPanel');
      });
    } else {
      instance.setToolMode('AnnotationEdit');
      instance.loadDocument(url);
    }
  };



  function initializeHeader(instance) {
    const { setHeaderItems } = instance;

    setHeaderItems(header => {
      // Add upload file button
      header.push({
        type: 'actionButton',
        img: `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M11 15H13V9H16L12 4L8 9H11V15Z" fill="currentColor"/>
        <path d="M20 18H4V11H2V18C2 19.103 2.897 20 4 20H20C21.103 20 22 19.103 22 18V11H20V18Z" fill="currentColor"/>
        </svg>`,
        title: 'Load file',
        dataElement: 'audio-loadFileButton',
        onClick: () => {
          inputFile.current.click();
        }
      });
    });
  }


  let history = useHistory();

  return (
    <div className="App">
      <div className={showLoading ? "gray-out" : " "}>

        <div>
          <div style={{ backgroundColor: 'rgb(152 154 159)' }}>
          <Link
              to={`/videoplayer/${eventId}`}
            >
              <Button  style={{ backgroundColor: '#747578' }}>Back </Button>
            </Link>



            {/* <Button onClick={() => history.goBack()} style={{ backgroundColor: '#747578' }}>Back </Button> */}
            <button className="annotationbtn" onClick={() => saveAnnotationVideo()}>
              Save Annoted Video
            </button>


            {/* <Link
              to={{
                pathname: "/videoeditor", state: { clippingURL: props.location.state.annotVidURL },
              }}
            >
              <Button className="Clippinng" style={{ backgroundColor: '#747578', float: "right" }}>
                Video Cutter
              </Button>
            </Link> */}

          </div>

          <input type="file" hidden ref={inputFile} onChange={onFileChange} value="" />
          <div className="webviewer" ref={viewer} />

        </div>

        <Modal id="mwidth" show={showModal} onHide={() => { handleModelfiveClose() }} >
          <Modal.Header closeButton>
            {/* <h6 className="fs-20 semi-bold black">Choose Option</h6> */}
          </Modal.Header>
          <Modal.Body>
            <div className="row">
              <div className="col-md-6 col-lg-6">
                <label className="fs-16 semi-bold black">Enter the name for Annotated video</label>
                <div className="clear10"></div>
                <input type="text" className="olnone form-control regular" placeholder="Enter video name"
                  onChange={(event) => {
                    savePlaylistName(event.target.value)
                  }}></input>
                <div className="errorMsg fs-14 medium">
                  {errorPlaylistName}
                </div>
              </div>
            </div>
          </Modal.Body>
          <Modal.Footer>
            <button
              type="button"
              className="cancelbtn mr-2"
              onClick={() => handleModelfiveClose()}
            >
              Cancel
            </button>
            <button
              type="submit"
              className="savebtn"
              onClick={() => saveAnnotationVideoSaveApi()}
            >
              Save
            </button>
            {/* <Button className="fs-16 regular" onClick={() => { this.handleModelfive() }}>
              Post
              </Button> */}



          </Modal.Footer>
        </Modal>

        {showLoading && (
          <CircularProgress
            style={{
              width: "45px",
              height: "44px",
              position: "absolute",
              left: "50%",
              top: "50%",
              zIndex: "99",
            }}
            color="secondary"
          />
        )}


        <Dialog
          id="dialogBoxCancel" className="dialog-style"
          open={openSuccessDialogue}
          onClose={handleDialogueClose}
        >
          <DialogTitle>
            <div className="row">
              <div className="col-1 text-right ml-auto">
                <BsXLg
                  onClick={handleDialogueClose}
                  className="crossview cp"
                ></BsXLg>
              </div>
            </div>
          </DialogTitle>
          <DialogContent>
            <div className="clear10"></div>
            <div className="row">
              <div className="col-12 text-center">
                <img src={successimg} alt="success" className="successimg-new"></img>
                <div className="clear20"></div>
                <p className="fs-20 semi-bold text-center">
                  Video Annotation added Successfully.
                </p>
                <div className="clear30"></div>
              </div>
              <div className="col-12 col-md-12 col-lg-12 ml-auto text-center">
                <Link to={`/videoplayer/${eventId}`}>
                  <button
                    type="button"
                    class="donebtn"
                    onClick={handleDialogueClose}
                  >
                    OK
                  </button>
                </Link>
              </div>

            </div>

            <div className="clear10"></div>

            <div className="clear10"></div>
          </DialogContent>
        </Dialog>

        {/* end */}
      </div>
    </div>
  );
};

export default PdfTorn;






